import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonHttpService } from '../../services/common-http.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ExportResponse } from '../../../views/report-details/interfaces/report-details.interface';
import { CommonMethods, Severity } from '../../helpers/common-methods';
import { FilterType, ReportType } from '../../../views/report-details/interfaces/report-details.interface';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'bi-mobile-view',
  standalone: false,
  templateUrl: './mobile-view.component.html',
  styleUrl: './mobile-view.component.scss'
})
export class MobileViewComponent {

  ReportType = ReportType;
  FilterType = FilterType;
  editingItemCode: any = null;
  editColumn: string = '';
  tableData: any[] = [];
  clickOnPreview: boolean = false;

  @Input() mobileReportInfo: any;

  constructor(private _commonMethods: CommonMethods, private _commonHttpService: CommonHttpService, private _commonService: CommonService) {
  }

  ngOnInit() {
    this.mobileReportInfo = {...this.mobileReportInfo};
    this.mobileReportInfo.groupByFilters = this.cloneObject(this.mobileReportInfo.groupByFilters);
    this.mobileReportInfo.columns = this.cloneObject(this.mobileReportInfo.columns);
    console.log("mobileReportInfo", this.mobileReportInfo);
  }

  ngAfterViewInit() {
    //this.mobilePreview();
    this.clickOnPreview = true;
  }

  cloneObject(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }


  getChooseColumns() {
    return Object.values(this.mobileReportInfo.orgColumns).filter((column: any) => (true)).map((column: any) => {
      //console.log("column", column);
      if (this.mobileReportInfo.reportType == ReportType.DIMENSION_REPORT) {
        return {
          name: column.columnName,
          code: 'd' + column.columnId,
          id: column.id
        }
      }
      return {
        name: column.columnName,
        code: column.columnId,
        id: column.id
      }
    }).sort((a: any, b: any) => a.mobileReportColOrder - b.mobileReportColOrder);
  }

  getColumnInfo(columnId: any) {
    return this.mobileReportInfo.columns[columnId] || null;
  }

  getGroupByColumnInfo(columnId: any) {
    return this.mobileReportInfo.groupByFilters[columnId] || null;
  }


  getGroupByColumns() {
    return Object.values(this.mobileReportInfo.orgGroupByFilters).filter((column: any) => (true)).map((column: any) => {
      return {
        name: column.columnName,
        code: column.columnId,
        id: column.id
      }
    });
  }

  startEditing(item: any, columnName: any) {
    if (!item) {
      console.warn('startEditing called with null item');
      return;
    }

    this.editColumn = columnName || '';
    this.editingItemCode = item;

    // Focus the input field after a short delay to ensure DOM is updated
    // setTimeout(() => {
    const inputElement = document.getElementById(`editColumn_${item}`) as HTMLInputElement;
    console.log('inputElement', inputElement);
    if (inputElement) {
      inputElement.focus();
      inputElement.select();
    }
    // }, 100);
  }

  stopEditing() {
    this.editingItemCode = null;
    this.editColumn = '';
  }

  updateItemName(item: any, newValue: string, listType: 'columns' | 'groupByFilters') {
    if (!item) {
      console.warn('updateItemName called with null item');
      this.stopEditing();
      return;
    }

    /* if (newValue && newValue.trim()) {
      // Update the column name in the allColumnsData
      if (this.allColumnsData[item]) {
        this.allColumnsData[item].columnName = newValue.trim();
      }

      // Update the form value to trigger change detection
      const currentColumns = this.reportForm.get('columns')?.value || [];
      this.reportForm.get('columns')?.setValue([...currentColumns]);

      // Trigger change detection
      this._changeDetectorRef.detectChanges();
    } */
    if (newValue && newValue.trim()) {
      // ✅ ONLY update the column name in the allColumnsData
      if (this.mobileReportInfo[listType][item]) {
        this.mobileReportInfo[listType][item].columnName = newValue.trim();
      }

      // ❌ REMOVE THESE LINES - No form update or change detection
      // const currentColumns = this.reportForm.get('columns')?.value || [];
      // this.reportForm.get('columns')?.setValue([...currentColumns]);
      // this._changeDetectorRef.detectChanges();
    }
    this.stopEditing();
  }

  removeColumn(option: any) {
    this.mobileReportInfo.columnsList = this.mobileReportInfo.columnsList.filter((column: any) => column !== option);
    this.editingItemCode = null;
    this.clickOnPreview = true;
    //this.mobilePreview();
  }

  saveColumn(option: any) {
    this.mobileReportInfo.columns[option].columnName = this.editColumn;
    this.editingItemCode = null;
  }

  cancelEditing(option: any) {
    this.editingItemCode = null;
    this.editColumn = '';
  }

  // Drag and Drop methods for custom displays
  onDragStart(event: DragEvent, index: number, listType: 'columns' | 'groupByFilters' | 'sortColumns') {
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', index.toString());
      event.dataTransfer.effectAllowed = 'move';
    }
    // Add visual feedback
    const target = event.target as HTMLElement;
    if (target) {
      target.style.opacity = '0.5';
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'move';

    // Add visual feedback for drop zone
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('border-bottom')) {
      target.style.backgroundColor = '#f0f0f0';
    }
  }

  onDragLeave(event: DragEvent) {
    // Remove visual feedback when leaving drop zone
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('border-bottom')) {
      target.style.backgroundColor = '';
    }
  }

  onDrop(event: DragEvent, dropIndex: number, listType: 'columns' | 'groupByFilters' | 'sortColumns') {
    event.preventDefault();

    // Remove visual feedback
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('border-bottom')) {
      target.style.backgroundColor = '';
    }

    const dragIndex = parseInt(event.dataTransfer!.getData('text/plain'));

    if (dragIndex === dropIndex) return;

    let currentItems: any[] = [];
    let formControlName = '';

    switch (listType) {
      case 'columns':
        currentItems = [...this.mobileReportInfo.columnsList || []];
        formControlName = 'columnsList';
        break;
      case 'groupByFilters':
        currentItems = [...this.mobileReportInfo.groupByColumnsList || []];
        formControlName = 'groupByColumnsList';
        break;
    }

    if (currentItems.length > 0) {
      const draggedItem = currentItems[dragIndex];
      currentItems.splice(dragIndex, 1);
      currentItems.splice(dropIndex, 0, draggedItem);
      this.mobileReportInfo[formControlName] = currentItems;
    }
    this.clickOnPreview = true;
  }

  onDragEnd(event: DragEvent) {
    // Reset visual feedback
    const target = event.target as HTMLElement;
    if (target) {
      target.style.opacity = '';
    }
  }

  removeGroupByFilter(option: any) {
    this.mobileReportInfo.groupByColumnsList = this.mobileReportInfo.groupByColumnsList.filter((filter: any) => filter !== option);
    this.editingItemCode = null;
    this.clickOnPreview = true;
    //this.mobilePreview();
  }

  mobilePreview() {
    if (!this.validateColumnsAndGroupByColumns()) {
      return;
    }
    this.tableData = [];
    this._commonHttpService.getReportData(this.getReportPostData()).subscribe((data: any) => {
      this.tableData = data.aaData;
      this.clickOnPreview = false;
    });
  }

  getReportPostData(forSave: boolean = false) {
    const tempMobileReportInfo = {...this.mobileReportInfo};
    delete tempMobileReportInfo.orgGroupByFilters;
    delete tempMobileReportInfo.orgColumns;
    if (!forSave) {
      delete tempMobileReportInfo.columns;
      delete tempMobileReportInfo.groupByFilters;
    }
    delete tempMobileReportInfo.getColumnInfo;
    delete tempMobileReportInfo.allColumnsData;
    delete tempMobileReportInfo.userConfig;
    delete tempMobileReportInfo.reportConfig;
    delete tempMobileReportInfo.dimensionColumnsOptions;
    tempMobileReportInfo.mobPreview = 1;
    tempMobileReportInfo.rows = 15;
    return {
      ...tempMobileReportInfo
    };
  }

  onGroupByFiltersChange(event: any) {
    const groupByFiltersControl = this.mobileReportInfo.groupByColumnsList;
    if (groupByFiltersControl) {
      if (event.value.length > 1) {
        event.value.pop();
        this.mobileReportInfo.groupByColumnsList = event.value;
        //groupByFiltersControl.setValue(event.value);
        this._commonMethods.showToastMessage('Please select at most 1 column', '', Severity.error as Severity);
        //groupByFiltersControl.disable();
      }
    }
    //this.mobilePreview();
    this.clickOnPreview = true;
  }

  onColumnsChange(event: any) {
    this.clickOnPreview = true;
    const columnsControl = this.mobileReportInfo.columnsList;
    if (columnsControl) {
      if (event.value.length > 5 - this.mobileReportInfo.groupByColumnsList.length) {
        event.value.pop();
        this.mobileReportInfo.columnsList = event.value;
        this._commonMethods.showToastMessage('You can select upto ' + (5 - this.mobileReportInfo.groupByColumnsList.length) + ' columns', '', Severity.error as Severity);
      }
    }
    //this.mobilePreview();
  }

  saveAsMobileReport() {
    if (!this.validateColumnsAndGroupByColumns()) {
      return;
    }
    this._commonHttpService.saveMobileReport(this.getReportPostData(true)).subscribe((data: any) => {
      this._commonMethods.showToastMessage('Mobile Report saved successfully', '', Severity.success as Severity);
      this.mobileReportInfo.visible = false;
      console.log("data", this.mobileReportInfo);
      console.log("this.mobileReportInfo", { moduleId: this.mobileReportInfo.reportId, reportId: this.mobileReportInfo.userReportId, reloadSavedReportData: true });
      // Set the data and trigger the subscription
      this._commonService.setReloadSavedReportData = { moduleId: this.mobileReportInfo.reportId, reportId: this.mobileReportInfo.userReportId, reloadSavedReportData: true };
      this._commonService.triggerGetSavedReportData();
    });
  }

  validateColumnsAndGroupByColumns() {
    if (!this.mobileReportInfo.columnsList) {
      this._commonMethods.showToastMessage('Please select at least 1 column', '', Severity.error as Severity);
      return false;
    }
    if (!this.mobileReportInfo.groupByColumnsList && this.mobileReportInfo.reportType != ReportType.DETAILED_REPORT) {
      this._commonMethods.showToastMessage('Please select at least 1 group by column', '', Severity.error as Severity);
      return false;
    }
    return true;
  }
}
